import { updatePlanningInboxTableRows } from '@/entities/gridTables/thunks/updatePlanningInboxTableRows'
import { BusinessModelEnum } from '@/entities/user/models/BusinessModel'
import { OLMSApiService } from '@/shared/apis'
import { ThunkApiContext } from '@/shared/store'
import { createAsyncThunk, EntityId } from '@reduxjs/toolkit'

import { Order } from '../models/Order'
import { replaceAllOrders, upsertMultipleOrders } from '../ordersSlice'

type FetchOrdersPayload = {
  orderIds: (EntityId | undefined)[] // If orderIds is [], the API will return all orders
}

export const fetchPlanningOrders = createAsyncThunk<Order[], FetchOrdersPayload, ThunkApiContext>('orders/fetchPlanningOrders', async ({ orderIds }, { getState, dispatch }) => {
  const state = getState()
  const businessModel = state.user.businessModel
  const filteredOrderIds = orderIds.filter((orderId) => orderId !== undefined)
  const orders = await OLMSApiService.post<Order[]>('/planning/orders', filteredOrderIds)

  if (!orders || orders.length === 0) return []

  // Process orders prior to upsert
  let i = 0

  for (i = 0; i < orders.length; i++) {
    const order = orders[i]

    if (businessModel === BusinessModelEnum.Depot) {
      if (order.isPickup) {
        order.location = order.fromLocation
        order.depotId = order.toLocation.id
        order.depot = order.toLocation
        order.serviceTime = order.serviceTimePickup
      } else {
        order.location = order.toLocation
        order.depot = order.fromLocation
        order.depotId = order.fromLocation.id
        order.serviceTime = order.serviceTimeDelivery
      }
    }
  }


  if (orderIds.length === 0) {
    // If orderIds is [], we are fetching every orders and should replace all orders in the store
    dispatch(replaceAllOrders(orders))
    dispatch(updatePlanningInboxTableRows())
  } else {
    dispatch(upsertMultipleOrders(orders))
  }

  return orders
})
